(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 7286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(94);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/container/base.jsx + 3 modules
var base = __webpack_require__(5216);
;// CONCATENATED MODULE: ./components/container/default.jsx

function Default(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col max-w-7xl mx-auto px-6",
        children: children
    });
}

;// CONCATENATED MODULE: ./components/container/index.jsx
// COMPONENTS



function Container(param) {
    let { children , blackOut , noFooter  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* default */.Z, {
        blackOut: blackOut,
        noFooter: noFooter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Default, {
            children: children
        })
    });
}


/***/ }),

/***/ 7827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2940);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3023);



function Input(param) {
    let { title , name , type , register , errors , placeholder , min , max , notReq , background ="bg-gray-50" , disabled =false , valid  } = param;
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mx-auto",
        children: [
            errors && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-red-500 text-start w-full ",
                children: errors === null || errors === void 0 ? void 0 : errors.message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(errors ? "border-red-600 " : "border-gray-500 ", " relative  border-b p-2  shadow-sm focus-within:border-indigo-600 focus:outline-none w-full "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: toggle || type,
                        placeholder: placeholder,
                        minlength: min,
                        maxlength: max,
                        disabled: disabled,
                        className: " block w-full border-0 p-0 text-softWhite placeholder-gray-500 bg-black focus:ring-0  focus:outline-none sm:text-xl",
                        ...register(name, {
                            required: notReq ? false : "Please enter a ".concat(name),
                            validate: valid || null
                        })
                    }),
                    type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: ()=>setToggle((current)=>current ? null : "text"),
                        className: "absolute top-2 right-6 text-gray-500 hover:text-gray-700",
                        children: toggle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "h-5 w-5"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "h-5 w-5"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pageLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function pageLoading() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-center items-center h-screen w-screen gap-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballOne"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballTwo"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballThree"
            })
        ]
    });
}


/***/ }),

/***/ 6337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useOnboarding; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 2 modules
var useMutation = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(7283);
;// CONCATENATED MODULE: ./lib/requests.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation submitJackalopeRequest(\n    $email: String!\n    $name: ID!\n    $employees: String!\n  ) {\n    submitJackalopeRequest(\n      numberOfEmployees: $employees\n      orgName: $name\n      requestEmail: $email\n    ) {\n      success\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation analyzeDoc($query: String!) {\n    analyzeDoc(query: $query) {\n      response\n      error\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation logInboundReferral($IP: String!, $ref: String!) {\n    logInboundReferral(affiliateReferenceId: $ref, prospectIdentifier: $IP) {\n      success\n      error\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation offerEmailCapture($email: String!) {\n    offerEmailCapture(email: $email) {\n      success\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation publicProjectValidation(\n    $email: String!\n    $endResultStatement: String!\n    $problemStatement: String!\n    $solutionStatement: String!\n  ) {\n    publicProjectValidation(\n      email: $email\n      endResultStatement: $endResultStatement\n      problemStatement: $problemStatement\n      solutionStatement: $solutionStatement\n    ) {\n      response\n      error\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation consultingLeadWeb(\n    $name: String!\n    $email: String!\n    $company: String!\n  ) {\n    companyLeadCapture(\n      companyPurpose: $company\n      fullName: $name\n      email: $email\n    ) {\n      success\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const SUBMIT_JACKALOPE = (0,lib/* gql */.Ps)(_templateObject());
const ASK = (0,lib/* gql */.Ps)(_templateObject1());
const LOG_REFERRAL = (0,lib/* gql */.Ps)(_templateObject2());
const EMAIL_CAPTURE = (0,lib/* gql */.Ps)(_templateObject3());
const VALIDATION = (0,lib/* gql */.Ps)(_templateObject4());
const LEAD = (0,lib/* gql */.Ps)(_templateObject5());

;// CONCATENATED MODULE: ./hooks/useOnboarding.js




// REQUESTS

const useDocuments = ()=>{
    const [openModal, setOpenModal] = (0,react.useState)(false);
    const [validation, setValidation] = (0,react.useState)({});
    const [response, setResponse] = (0,react.useState)(null);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setOpenModal(true);
        }, 40000); // 40 seconds
        return ()=>clearTimeout(timer);
    }, []);
    // REQUESTS
    /************************************************************************* */ const [inquire, inquiryResponse] = (0,useMutation/* useMutation */.D)(SUBMIT_JACKALOPE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>router.push("/thankyou"),
        onError: (d)=>alert(d)
    });
    const [logRef, refResponse] = (0,useMutation/* useMutation */.D)(LOG_REFERRAL, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>console.log(d),
        onError: (d)=>console.log(d)
    });
    const [logEmail, emailResponse] = (0,useMutation/* useMutation */.D)(EMAIL_CAPTURE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            if (openModal) setOpenModal(false);
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    const [validate, validationResponse] = (0,useMutation/* useMutation */.D)(VALIDATION, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            setResponse(d.publicProjectValidation.response);
        },
        onError: (d)=>console.log(d)
    });
    const [logPriceEmail, priceResponse] = (0,useMutation/* useMutation */.D)(EMAIL_CAPTURE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            if (openModal) setOpenModal(false);
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    const [capture, captureResponse] = (0,useMutation/* useMutation */.D)(LEAD, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    // FUNCTIONS
    /************************************************************************* */ async function inquireJackalope(data) {
        inquire({
            variables: data
        });
    }
    async function logReferral(data) {
        var _IP_data;
        const IP = await axios/* default.get */.Z.get("https://geolocation-db.com/json/");
        logRef({
            variables: {
                IP: (_IP_data = IP.data) === null || _IP_data === void 0 ? void 0 : _IP_data.IPv4,
                ref: data
            }
        });
    }
    async function submitEmail(data) {
        capture({
            variables: data
        });
    }
    async function priceEmail(data) {
        logEmail({
            variables: {
                email: data.email
            }
        });
    }
    async function submitFeedback(data) {
        setValidation(data);
        validate({
            variables: {
                email: data.email,
                endResultStatement: data.result,
                problemStatement: data.problem,
                solutionStatement: data.solution
            }
        });
    }
    return {
        isLoading: captureResponse.loading || validationResponse.loading || inquiryResponse.loading || emailResponse.loading,
        openModal,
        setOpenModal,
        inquireJackalope,
        submitEmail,
        priceEmail,
        submitFeedback,
        validation,
        logReferral,
        response
    };
};
/* harmony default export */ var useOnboarding = (useDocuments);


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.84b77a51.png","height":407,"width":613,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJFBMVEVMaXH4TSH/VCP3SyP6SCH5SSL4SB/6SB/7SCD3SCT5RyD4SCCUBaGTAAAADHRSTlMAFQoqRILQ65QjVptcvAuiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVR4nCXFuQ0AIBAEsdn7gf77RQInhkf6EwswWVSATVcfxzO3C10GQQBrpKbfmwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "jackrabbitops",
    blogTitle: "Blog",
    baseUrl: "jackrabbitops.com",
    websiteLogo: logo,
    twitterHandle: "@junaid.sudo",
    twitterCardType: "JackRabbit Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI project manager ",
    defaultPageTitle: "Privacy | JackRabbit Ops"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Jackrabbit Ops",
    defaultPageTitle: "FAQ | JackRabbit Ops"
};
const landing = {
    ...config,
    siteDescription: "Respond instantly to all your leads, qualify them and book meetings all on autopilot. All at a fraction of the cost of an SDR. ",
    defaultPageTitle: "Never miss a new customer | Jackrabbit Ops "
};
const demo = {
    ...config,
    siteDescription: "See Jackrabbit Ops in action, instantly responding to RFQs and qualifying the leads for you.",
    defaultPageTitle: "Instantly qualify leads | Jackrabbit Ops "
};
const offer = {
    ...config,
    siteDescription: "Try for free. Upgrade to the low-cost paid plan of $16/user to unlock your team's success.",
    defaultPageTitle: "Pricing | JackRabbit Ops"
};
const thankYou = {
    ...config,
    siteDescription: "Our team will be in touch to get you onboarded for your AI project manager.",
    defaultPageTitle: "Get In Touch | JackRabbit Ops"
};
const blogHome = {
    ...config,
    siteDescription: "Explore project management best practices and latest news with Jackrabbit Ops.",
    defaultPageTitle: "Blog | JackRabbit Ops"
};
const features = {
    ...config,
    siteDescription: "Jackrabbit Ops AI manager recognizes roadblocks and highlights them to roles that can solve them.",
    defaultPageTitle: "AI Manager Features | JackRabbit Ops"
};
const challenge = {
    ...config,
    siteDescription: "Productive team or your money back",
    defaultPageTitle: "90 Day Challenge | JackRabbit Ops"
};
const configSet = {
    FAQ,
    features,
    privacy,
    landing,
    blogHome,
    offer,
    challenge,
    thankYou,
    demo
};


/***/ }),

/***/ 94:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ArticlesIndex; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./utils/seo.js
var seo = __webpack_require__(3298);
// EXTERNAL MODULE: ./lib/pageConfig.js + 1 modules
var pageConfig = __webpack_require__(3517);
// EXTERNAL MODULE: ./components/container/index.jsx + 1 modules
var container = __webpack_require__(3223);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./hooks/useOnboarding.js + 1 modules
var hooks_useOnboarding = __webpack_require__(6337);
// EXTERNAL MODULE: ./components/inputs/whiteText.jsx
var whiteText = __webpack_require__(7827);
// EXTERNAL MODULE: ./components/loading/page.jsx
var page = __webpack_require__(7733);
;// CONCATENATED MODULE: ./components/modal/cover.jsx




//HOOKS

//COMPONENTS


function CoverModal() {
    const { isLoading , openModal , setOpenModal , submitEmail  } = useOnboarding();
    const { register , handleSubmit , formState: { errors  }  } = useForm();
    if (isLoading) return /*#__PURE__*/ _jsx(Loading, {});
    return /*#__PURE__*/ _jsx(Transition.Root, {
        show: openModal,
        as: Fragment,
        children: /*#__PURE__*/ _jsxs(Dialog, {
            as: "div",
            className: "relative z-[60]",
            onClose: setOpenModal,
            children: [
                /*#__PURE__*/ _jsx(Transition.Child, {
                    as: Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ _jsx(Transition.Child, {
                            as: Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ _jsx(Dialog.Panel, {
                                className: "relative transform overflow-hidden bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full h-[100vh] sm:p-6",
                                children: /*#__PURE__*/ _jsxs("form", {
                                    onSubmit: handleSubmit(submitEmail),
                                    className: "max-w-4xl mx-auto flex flex-col items-center text-center justify-center h-full text-softWhite",
                                    children: [
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: " text-3xl lg:text-6xl font-header mb-8",
                                            children: "Want to make sure R&D projects get done on time?"
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: "text-base lg:text-lg block my-2 text-gray-200 font-light font-copy max-w-3xl mx-auto",
                                            children: [
                                                "Join ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "font-bold",
                                                    children: "5,603 businesses"
                                                }),
                                                " ",
                                                "already in our",
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "font-bold",
                                                    children: "90 Day AI Challenge."
                                                }),
                                                " To use Jackrabbit Ops to get",
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "font-bold",
                                                    children: "milestones completed on time."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: "text-base lg:text-lg block my-2 text-gray-200 font-light font-copy max-w-3xl mx-auto",
                                            children: [
                                                "If after 90 days your team isn't shockingly productive and happy",
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "font-bold",
                                                    children: "We will return every dollar you paid."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex items-center space-x-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "flex flex-shrink-0 -space-x-1 mt-4 mb-12",
                                                children: members.map((member)=>/*#__PURE__*/ _jsx("img", {
                                                        className: "h-10 lg:h-12 2-10 lg:w-12 max-w-none rounded-full ring-2 ring-softWhite",
                                                        src: member.imageUrl,
                                                        alt: member.name
                                                    }, member.handle))
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Input, {
                                            title: "Business Email",
                                            name: "email",
                                            type: "email",
                                            placeholder: "elon@spaceX.com",
                                            register: register,
                                            errors: errors.email,
                                            white: true
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-8",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                type: "submit",
                                                className: "text-lg lg:text-2xl bg-jackOrange text-white hover:text-jackOrange w-full text-center relative px-7 py-3 border border-jackOrange hover:bg-softWhite rounded-lg leading-none flex justify-center items-center divide-x divide-gray-600",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: "pb-[0.09rem] transition duration-200 ",
                                                    children: "Yes, Please! →"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            onClick: ()=>setOpenModal(false),
                                            className: "underline font-thin text-base lg:text-lg mt-6 text-softWhite cursor-pointer hover:text-gray-500",
                                            children: "No, I like wasting time and money."
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
const members = [
    {
        name: "Dries Vincent",
        handle: "driesvincent",
        imageUrl: "https://images.unsplash.com/photo-1504199367641-aba8151af406?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Lindsay Walton",
        handle: "lindsaywalton",
        imageUrl: "https://images.unsplash.com/photo-1611873636366-cb3619248691?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Courtney Henry",
        handle: "courtneyhenry",
        imageUrl: "https://images.unsplash.com/photo-1548142542-c53707f8b05b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Tom Cook",
        handle: "tomcook",
        imageUrl: "https://images.unsplash.com/photo-1559637621-d766677659e8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Dries Vincent",
        handle: "driesvincenat",
        imageUrl: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Lindsay Walton",
        handle: "lindsaywaltodn",
        imageUrl: "https://images.unsplash.com/photo-1614947897387-7896d478bb07?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Courtney Henry",
        handle: "courtneyhenfry",
        imageUrl: "https://images.unsplash.com/photo-1520529277867-dbf8c5e0b340?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    {
        name: "Tom Cook",
        handle: "tomcookx",
        imageUrl: "https://images.unsplash.com/photo-1610069302033-6fee1f5791d2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    }
];

;// CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js


function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
  }));
}

const ForwardRef = react.forwardRef(ChevronRightIcon);
/* harmony default export */ var esm_ChevronRightIcon = (ForwardRef);
;// CONCATENATED MODULE: ./components/blog/Card.jsx




function Card(param) {
    let { as: Component = "div" , className , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        className: clsx_m(className, "group relative flex flex-col items-start text-softWhite hover:text-black"),
        children: children
    });
}
Card.Link = function CardLink(param) {
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute -inset-y-6 -inset-x-4 z-0 scale-95 bg-zinc-50 opacity-0 transition group-hover:scale-100 group-hover:opacity-100 dark:bg-zinc-800/50 sm:-inset-x-6 sm:rounded-2xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute -inset-y-6 -inset-x-4 z-20 sm:-inset-x-6 sm:rounded-2xl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "relative z-10",
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
Card.Title = function CardTitle(param) {
    let { as: Component = "h2" , href , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        className: "text-base font-semibold tracking-tight ",
        children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Link, {
            href: href,
            children: children
        }) : children
    });
};
Card.Description = function CardDescription(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "relative z-10 mt-2 text-sm ",
        children: children
    });
};
Card.Cta = function CardCta(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-hidden": "true",
        className: "relative z-10 mt-4 flex items-center text-sm font-medium text-[#F6800A] mb-1",
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                className: "ml-1 -mb-1 h-4 w-4 text-[#F6800A]"
            })
        ]
    });
};
Card.Eyebrow = function CardEyebrow(param) {
    let { as: Component = "p" , decorate =false , className , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, {
        className: clsx_m(className, "relative z-10 order-first mb-3 flex items-center text-sm ", decorate && "pl-3.5"),
        ...props,
        children: [
            decorate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute inset-y-0 left-0 flex items-center",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "h-4 w-0.5 rounded-full bg-zinc-200 dark:bg-zinc-500"
                })
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./pages/blog/index.js









function Article(param) {
    let { article  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/".concat(article.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "text-gray-800 border-l border-white hover:bg-white hover:text-gray-800 hover:rounded-lg p-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: article.imageUrl,
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-header font-bold",
                    children: article.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm text-gray-600",
                    children: dayjs_min_default()(article.publishDate).format("MMM D, YYYY")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-sm text-gray-600 ",
                    children: article.seoDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Cta, {
                    children: "Read article"
                })
            ]
        })
    });
}
var __N_SSG = true;
function ArticlesIndex(param) {
    let { articles =[]  } = param;
    var _articles_;
    const main = articles === null || articles === void 0 ? void 0 : articles.slice(1, 3);
    const remainder = articles === null || articles === void 0 ? void 0 : articles.slice(3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                ...(0,seo/* createSEOPageConfig */.Cd)(pageConfig/* configSet.blogHome */.r.blogHome)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " min-h-screen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: "text-black mt-24 mb-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mt-10 text-5xl font-header tracking-tight text-gray-900 sm:text-6xl",
                                children: "Mastering Sales Success, Your Ultimate Guide"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-6 text-lg leading-8 text-gray-600",
                                children: "Dive into insights and effective strategies to supercharge your sales process, powered by Jackrabbit Ops, your key to unlocking exceptional results."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:pl-6 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:grid grid-cols-2 gap-4 border-b pb-4 border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
                                        article: articles[0]
                                    }, (_articles_ = articles[0]) === null || _articles_ === void 0 ? void 0 : _articles_.slug),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col lg:grid grid-cols-2 gap-4",
                                        children: main.map((entry)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Article, {
                                                article: entry
                                            }, entry === null || entry === void 0 ? void 0 : entry.slug);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-start lg:grid grid-cols-4 gap-4 h-full",
                                children: remainder.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
                                        article: article
                                    }, article.slug))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ }),

/***/ 1068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(2152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(8964);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/parser/index.js

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,globals/* invariant */.kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,globals/* invariant */.kG)(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,globals/* invariant */.kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 33);
    __DEV__ ? (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,globals/* invariant */.kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,globals/* invariant */.kG)(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,globals/* invariant */.kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,globals/* invariant */.kG)(operation.type === type, 36);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(5317);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js



function useApolloClient(override) {
    var context = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)());
    var client = override || context.client;
    __DEV__ ? (0,globals/* invariant */.kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,globals/* invariant */.kG)(!!client, 31);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js







function useMutation(mutation, options) {
    var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
    verifyDocumentType(mutation, DocumentType.Mutation);
    var _a = (0,react.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { mutation: mutation });
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,mergeOptions/* mergeOptions */.J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new client_errors/* ApolloError */.c({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,equality_esm/* equal */.D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, response.data, clientOptions);
            (_c = executeOptions.onCompleted) === null || _c === void 0 ? void 0 : _c.call(executeOptions, response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,equality_esm/* equal */.D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 ? void 0 : _c.call(_b, error, clientOptions);
                (_d = executeOptions.onError) === null || _d === void 0 ? void 0 : _d.call(executeOptions, error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib_es6/* __assign */.pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 2940:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function EyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(EyeIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 3023:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function EyeSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(EyeSlashIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [862,962,594,216,774,888,179], function() { return __webpack_exec__(7286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);